import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=63b693d8&scoped=true&"
import script from "./SelectField.vue?vue&type=script&lang=ts&"
export * from "./SelectField.vue?vue&type=script&lang=ts&"
import style0 from "./SelectField.vue?vue&type=style&index=0&id=63b693d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b693d8",
  null
  
)

export default component.exports